import React, { useState } from "react";
import "../../css/ParticipantsSummary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faUserCircle } from "@fortawesome/free-solid-svg-icons";

const ParticipantsSummary = ({ participants, showInsurance, krInsurance }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="participants-container">
      <h3>Lista osób</h3>
      {participants.map((participant, index) => (
        <div key={index} className="participant-box"  onClick={() => toggleExpand(index)}>
          <div className="participant-box-header">
            <div className="participant-details-box">
              <FontAwesomeIcon icon={faUserCircle} className="participant-icon" />
              <span className="participant-name">{participant.preferredName}</span>
            </div>
            <button className="participant-toggle-btn">
              <FontAwesomeIcon icon={expandedIndex === index ? faChevronUp : faChevronDown} />
            </button>
          </div>

          {expandedIndex === index && (
            <div className="participant-details">
              <table className="participant-table">
                <tbody>
                  <tr>
                    <td><strong>Email:</strong></td>
                    <td className="text-wrap">{participant.email}</td>
                  </tr>
                  <tr>
                    <td><strong>Telefon:</strong></td>
                    <td>{participant.phone}</td>
                  </tr>
                  <tr>
                    <td><strong>Osoba pełnoletnia:</strong></td>
                    <td>{participant.isAdult ? "Tak" : "Nie"}</td>
                  </tr>
                </tbody>
              </table>

              {showInsurance && (
                <div className="participant-insurance">
                  <h4>Szczegóły ubezpieczenia</h4>
                  <table className="insurance-table">
                    <tbody>
                      <tr>
                        <td><strong>Imię:</strong></td>
                        <td>{participant.insurance.firstName}</td>
                      </tr>
                      <tr>
                        <td><strong>Nazwisko:</strong></td>
                        <td>{participant.insurance.lastName}</td>
                      </tr>
                      <tr>
                        <td><strong>Data urodzenia:</strong></td>
                        <td>{participant.insurance.birthDate}</td>
                      </tr>
                      <tr>
                        <td><strong>Przewlekłe choroby:</strong></td>
                        <td>{participant.insurance.isChronicIllness ? "Tak" : "Nie"}</td>
                      </tr>
                      <tr>
                        <td><strong>Ubezpieczenie kosztów rezygnacji:</strong></td>
                        <td>{krInsurance ? "Tak" : "Nie"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ParticipantsSummary;
